import { render, staticRenderFns } from "./ChangeImage.vue?vue&type=template&id=06afd7b8&"
import script from "./ChangeImage.vue?vue&type=script&lang=js&"
export * from "./ChangeImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/devteam/projects/dominion-conference-app/ConferenceAdmin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports